import * as ui from "../ui";

var view = (entity: string) => new ui.Container({
    id: "DocContainer",
    classes: "mar-t-20",
    components: [
        new ui.Container({
            classes: "mar-b-9 mar-l-20 col-xs-12",
            components: [
                new ui.Checkbox({
                    type: "Checkbox",
                    id: "PrintPrinterFriendly",
                    label: "PrinterFriendly",
                    bindValue: entity + "PrinterFriendly",
                    containerClasses: "col-xs-3 report-checkbox mar-t-10 pad-r-0 mar-r-0"
                }),
                new ui.ComboBox({
                    id: "PrintFormat",
                    label: "SelectFormat",
                    bindValue: entity + "FormatId",
                    labelField: "CodeNumber",
                    valueField: "Id",
                    bsc: "col-xs-9",
                    inputBsc: " no-pad col-xs-8",
                    labelBsc: "col-xs-4",
                    required: true
                })
            ]
        })
    ]
});

export default view;
